export class AbacusGrpcTransformer {
    static grpcPointsStatsDailyToPointsStatsDaily(response) {
        return response.rows;
    }
    static grpcPointsStatsWeeklyToPointsStatsWeekly(response) {
        return response.rows;
    }
    static grpcPointsLatestToPointsLatest(response) {
        return response;
    }
}
//# sourceMappingURL=index.js.map